/* ╔══════════════════════════════════════════════════════════════════════════╗
 * ║  COPIAR ARQUIVO → src/components/forms/CategoryForm.js                   ║
 * ║  Dossiê: Ecossistema GoldenSisters – Painel Admin Web                    ║
 * ║  Versão: 2.0 – Normaliza e persiste `code`                               ║
 * ║  Data: 30/10/2025 (-03)                                                  ║
 * ║  Responsável: GPT-5 Thinking                                             ║
 * ║                                                                          ║
 * ║  Mudanças:                                                               ║
 * ║   • Normaliza prefixo (UPPERCASE, trim).                                 ║
 * ║   • Gera `code = prefix` e envia no payload.                             ║
 * ║   • Valida campos obrigatórios.                                          ║
 * ╚══════════════════════════════════════════════════════════════════════════╝ */
import React, { useState } from 'react';
import FormField from '../ui/FormField';
import { Loader2 } from 'lucide-react';

const CategoryForm = ({ onSave, onClose, categoryData = null }) => {
  const [name, setName] = useState(categoryData?.name || '');
  const [prefix, setPrefix] = useState(categoryData?.prefix || '');
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const normName   = (name || '').trim();
    const normPrefix = (prefix || '').toUpperCase().trim();
    const code       = normPrefix; // regra: code = prefix normalizado

    // validações mínimas e objetivas
    if (!normName || !normPrefix) return;
    if (normPrefix.length < 2 || normPrefix.length > 6) return;

    setIsSaving(true);
    try {
      const payload = { name: normName, prefix: normPrefix, code };
      await onSave(payload, categoryData?.id);
      onClose();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <FormField
        label="Nome da Categoria"
        id="categoryName"
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        required
        placeholder="Ex: Anéis"
      />

      <FormField
        label="Prefixo para SKU"
        id="categoryPrefix"
        type="text"
        value={prefix}
        onChange={e => setPrefix(e.target.value.toUpperCase())}
        required
        placeholder="Ex: AN"
        maxLength="6"
      />

      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-700 mt-6">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500"
        >
          Cancelar
        </button>

        <button
          type="submit"
          disabled={isSaving}
          className="px-6 py-2 bg-brand-gold text-brand-black font-semibold rounded-md hover:bg-yellow-500 flex items-center"
        >
          {isSaving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Salvar Categoria
        </button>
      </div>
    </form>
  );
};

export default CategoryForm;
